import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { api } from "../axiosClient";
import { useEnquiryContext } from "../context/EnquiryContext";

const AdminLayout = () => {
  const location = useLocation();
  const [enquiryCount, setEnquiryCount] = useState(0);
  const { newCount: newEnquiryCount } = useEnquiryContext();

  useEffect(() => {
    const fetchEnquiryCount = async () => {
      try {
        const res = await api.get("/api/enquiries/count");
        setEnquiryCount(res.data?.count || 0);
      } catch (err) {
        console.error("Failed to fetch enquiry count:", err);
      }
    };
    fetchEnquiryCount();
  }, []);

  const navItems = [
    { label: "Dashboard", path: "/admin/dashboard" },
    { label: "Orders", path: "/admin/orders" },
    { label: "Products", path: "/admin/products" },
    {
      label: "Export Enquiries",
      path: "/admin/enquiries",
      count: enquiryCount,
      newCount: newEnquiryCount,
    },
    { label: "Contact Enquiries", path: "/admin/contact-enquiries" },
    { label: "Coupons", path: "/admin/coupons" },

    // ✅ NEW ITEM — placed right below Coupons
    { label: "Post Blog", path: "/admin/post-blog" },
    { label: "Subscribers", path: "/admin/subscribers" },
  ];

  return (
    <div className="flex min-h-screen bg-[#f3f0e4] text-[#105132]">
      <aside className="w-64 p-4 bg-white shadow-lg">
        <h2 className="text-2xl font-bold mb-6">Nutrafox Admin</h2>

        <nav className="space-y-2">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`relative flex justify-between items-center px-4 py-2 rounded-lg font-medium ${
                location.pathname === item.path
                  ? "bg-[#105132] text-white"
                  : "hover:bg-[#236e47]/20"
              }`}
            >
              <span>{item.label}</span>

              {item.count > 0 && (
                <span className="ml-2 bg-[#c0a230] text-white text-xs font-semibold px-2 py-0.5 rounded-full">
                  {item.count}
                </span>
              )}

              {item.label === "Export Enquiries" && item.newCount > 0 && (
                <span className="absolute top-1 right-2 bg-red-600 text-white text-[10px] px-1.5 py-0.5 rounded-full font-bold animate-pulse">
                  {item.newCount} new
                </span>
              )}
            </Link>
          ))}
        </nav>
      </aside>

      <main className="flex-1 p-6 overflow-y-auto">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;